





import Vue from 'vue'
import config from '../../config'
import { isFeatureLive } from "../pages/settings/GhlLabs/features";
import { Company } from '../../models'
const CalendarV2Page = () => import('./CalendarV2Page.vue');
const CalendarV3Page = () => import('./CalendarV3Page.vue');
export default Vue.extend({
  components: {
    CalendarV2Page,
    CalendarV3Page
  },
  computed: {
    company() {
      return new Company(this.$store.getters['company/get']);
    },
    isNewCalendarViewEnabled(): boolean {
      if (config.mode !== 'production') {
        return true
      }
      return config.internalAgencyForLevelUp?.includes(this.company.id) || isFeatureLive("calendars.newCalendarView") || ((this.$store.getters['featureFlags/getForLocation']("calendars.newCalendarView")));
    }
  }
})
